<template>
  <div class="office-map-page">
    <div class="map-container" id="office-map">
      <OfficeMap @update-rba="updateRba" />
      <Calculator :rba="rba" class="calculator-overlay" />
      <div class="results-box-overlay">
        <!-- You might bind results here, assuming they are reactive properties -->
        <h2>{{ resultsText }}</h2>
      </div>

    </div>
  </div>
</template>

<script>
import OfficeMap from '@/components/OfficeMap.vue';
import Calculator from '@/components/Calculator.vue';


export default {
  components: {
    OfficeMap,
    Calculator
  },
  data() {
    return {
      rba: 0
    };
  },
  methods: {
    updateRba(value) {
      this.rba = value;
    }
  }
}
</script>

<style>
.map-container {
  /* Style the container here (height, width, etc.) */
  position: relative;

  height: 1080px;
}

.calculator-overlay {
  position: absolute;
  /* background-color: rgba(166, 216, 243, 0.5); */
  /* Adjust the last number for opacity level */

  bottom: 100px;
  right: 10px;
  z-index: 100;
}
</style>